import React, {Component, ReactNode} from "react"

import {Body} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import StepIndicatorDots from "@irati/ui/src/StepIndicatorDots"
import mainTheme from "@irati/ui/src/global/theme"

import {Wrapper, Image, Footer, Title, NextButton, FooterActions, ButtonWrapper} from "./styled"

interface OnboardingModalSteps {
  description: string
  image: string
  title: string
  actions?: ReactNode[]
}

interface Props {
  steps: OnboardingModalSteps[]
  currentStepNumber: number
  handleClick: () => void
}

interface State {
  steps: []
}

class Content extends Component<Props, State> {
  state: State = {
    steps: []
  }

  render() {
    const {handleClick, currentStepNumber, steps} = this.props
    const image = steps[currentStepNumber]?.image
    const title = steps[currentStepNumber]?.title
    const description = steps[currentStepNumber]?.description
    const actions = steps[currentStepNumber]?.actions

    let defaultCTAcopy = "platform.onboardingModal.cta.continue"
    if (currentStepNumber === steps.length) {
      defaultCTAcopy = "platform.onboardingModal.cta.gotIt"
    }

    return (
      <Wrapper>
        {image && (
          <div>
            <Image src={image} />
          </div>
        )}

        <Flex direction="column" marginBottom={5} marginTop={5} height="200px">
          <Title>
            <FormattedMessage id={title} />
          </Title>
          <Body color={mainTheme.colors.utility.contrast}>
            <FormattedMessage id={description} />
          </Body>
        </Flex>

        <Footer justifyContent="space-between" alignItems="center">
          <StepIndicatorDots stepCount={steps.length} currentStep={currentStepNumber} marginBottom={2} />
          {(actions && (
            <FooterActions>
              {actions?.length === 1 ? (
                <ButtonWrapper>{actions[0]}</ButtonWrapper>
              ) : (
                actions?.map((action) => <ButtonWrapper>{action}</ButtonWrapper>)
              )}
            </FooterActions>
          )) || (
            <NextButton onClick={handleClick}>
              <FormattedMessage id={defaultCTAcopy} />
            </NextButton>
          )}
        </Footer>
      </Wrapper>
    )
  }
}

export default Content
